import type { ScheduleModeConfig } from '../types';

export const selfScheduleAdhocModeConfig: ScheduleModeConfig = {
  key: 'self-schedule-adhoc',
  navigationStyle: 'stepper',
  steps: [
    { key: 'details', label: 'Details' },
    { key: 'slotSelectionEmail', label: 'Slot selection email' },
    { key: 'communication', label: 'Invites & emails' },
    { key: 'scorecard', label: 'Scorecard' },
  ],
  showSecondaryCta: false,
};
